export default () => {
    const translation = useTranslation();
    const locale = translation.getCurrentLocale() || useGetDefaultLocale();
    return locale.split('-')[1];
};
